import Vue from 'vue'
import axios from 'axios'
// import sas from 'surfandscan'
const DMS = new Vue({
  data () {
    return {
      gbl_host: '',
      sas_host: ''
    }
  },
  methods: {

    /**
     * Set the config of the surfAndScan client
     * @param config
     * @param fnSuccess
     * @param fnError
     */
    setConfig: function (config, fnSuccess, fnError) {
      let url = this.gbl_host + '/config'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(config),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Retrieves the configuration from the surfAndScan client.
     * @param fnSuccess
     * @param fnError
     */
    getConfig: function (fnSuccess, fnError) {
      let url = this.gbl_host + '/config'
      let params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'get',
        params: params,
        url: url,
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        }).catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    getVersion: function (fnSuccess, fnError) {
      Vue.prototype.$api.showIdle()
      let url = this.gbl_host + '/version'
      let params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }

      axios({
        method: 'get',
        params: params,
        url: url,
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        }).catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Delete the given category
     * @param guid of the category
     * @param fnSuccess
     * @param fnError
     */
    deleteStorageCategory: function (guid, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let postData = {
        method: 'DELETE',
        type: 'categories',
        guid: guid,
        name: ''
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(postData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Delete the given status
     * @param guid of the status
     * @param fnSuccess
     * @param fnError
     */
    deleteStorageStatus: function (guid, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let postData = {
        method: 'DELETE',
        type: 'status',
        guid: guid,
        name: ''
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(postData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Request a search from the storage with given request data.
     * @param reqData
     * @param fnSuccess
     * @param fnError
     */
    searchStorage: function (reqData, fnSuccess, fnError) {
      reqData['method'] = 'LIST'
      reqData['type'] = 'files'
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     *
     * @param catObject
     * @param fnSuccess
     * @param fnError
     */
    addStorageItemCategory: function (catObject, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'CREATE',
        type: 'categories',
        name: catObject.name
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     *
     * @param catObject
     * @param fnSuccess
     * @param fnError
     */
    addStorageItemStatus: function (catObject, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'CREATE',
        type: 'status',
        name: catObject.name
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Deletes a file from the storage by given file guid.
     * @param guid guid of the file
     * @param fnSuccess
     * @param fnError
     */
    deleteFileFromStorage: function (guid, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'DELETE',
        type: 'files',
        guid: guid
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     *
     * @param guids array of Guid
     * @param fnSuccess
     * @param fnError
     */
    deleteFilesFromStorage: function (guids, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'DELETE',
        type: 'files',
        guid: guids.join()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     *
     * @param guid
     * @param fileName
     */
    downloadStorageItem: function (guid, fileName) {
      let time = new Date().getTime()
      let urlAppend = 'time=' + time + '&token=' + Vue.prototype.$api.getAuthToken()
      function downloadURI (uri, name) {
        var link = document.createElement('a')
        link.download = name
        link.href = uri
        link.click()
      }
      var url = this.gbl_host + '/storage/item?method=DOWNLOAD&type=files&guid=' + guid + '&' + urlAppend
      console.log(url)
      downloadURI(url, fileName)
    },

    getCloudUploadUrl: function (base) {
      let urlAppend = 'token=' + Vue.prototype.$api.getAuthToken()
      let url = ''
      if (this.sas_host === '') {
        url = base + '/storage/upload?' + urlAppend
      } else {
        url = this.sas_host + '/storage/upload?' + urlAppend
      }
      console.log(url)
      return url
    },
    /**
     *
     * @param guid
     * @param time
     * @param name
     * @param categories
     * @param fnSuccess
     * @param fnError
     */
    updateStorageItem: function (guid, time, name, categories, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'UPDATE',
        type: 'categories',
        guid: guid,
        name: name,
        time: time,
        categories: categories.join()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     *
     * @param guids array of guids
     * @param time
     * @param name
     * @param categories array of category guids
     * @param fnSuccess
     * @param fnError
     */
    updateStorageItems: function (guids, time, name, categories, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'UPDATE',
        type: 'categories',
        guid: guids.join(),
        name: name,
        time: time,
        categories: categories.join()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     *
     * @param guid
     * @param time
     * @param name
     * @param categories
     * @param fnSuccess
     * @param fnError
     */
    updateStorageItemCategories: function (guid, time, name, categories, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'UPDATE',
        type: 'categories',
        guid: guid,
        name: name,
        time: time,
        categories: categories.join()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     *
     * @param guid
     * @param dataObject
     * @param fnSuccess
     * @param fnError
     */
    updateStorageFile: function (guid, dataObject, fnSuccess, fnError) {
      if (!dataObject) {
        dataObject = {}
      }
      dataObject.method = 'UPDATE'
      dataObject.type = 'files'
      dataObject.guid = guid
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = dataObject
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    updateStorageCategory: function (guid, extraFields, categorySelectWord, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'UPDATECATEGORY',
        type: 'categories',
        guid: guid,
        extraFields: extraFields,
        categorySelectWord: categorySelectWord
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Updates the status of given status guid
     * @param guid of the status
     * @param dataObject
     * @param fnSuccess
     * @param fnError
     */
    updateStorageItemStatus: function (guid, dataObject, fnSuccess, fnError) {
      if (!dataObject) {
        dataObject = {}
      }
      dataObject.method = 'UPDATE'
      dataObject.type = 'status'
      dataObject.guid = guid
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(dataObject),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    appendStorageItemHistory: function (guid, dataObject, fnSuccess, fnError) {
      if (!dataObject) {
        dataObject = {}
      }
      dataObject.method = 'APPEND'
      dataObject.type = 'fileHistory'
      dataObject.guid = guid
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(dataObject),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Updates the status of given storage item guids
     * @param guids array of guids
     * @param dataObject
     * @param fnSuccess
     * @param fnError
     */
    updateStorageItemsStatus: function (guids, dataObject, fnSuccess, fnError) {
      if (!dataObject) {
        dataObject = {}
      }
      dataObject.method = 'UPDATE'
      dataObject.type = 'fileStatus'
      dataObject.guid = guids.join()
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(dataObject),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Updates the categories of given storage item guids
     * @param guids array of guids
     * @param dataObject
     * @param fnSuccess
     * @param fnError
     */
    updateStorageItemsCategories: function (guids, dataObject, fnSuccess, fnError) {
      if (!dataObject) {
        dataObject = {}
      }
      dataObject.method = 'UPDATE'
      dataObject.type = 'fileCategories'
      dataObject.guid = guids.join()
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(dataObject),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Send a mail with given storage item guids as attachments
     * @param guids array of guids
     * @param dataObject
     * @param fnSuccess
     * @param fnError
     */
    mailSendStorageItems: function (guids, dataObject, fnSuccess, fnError) {
      if (!dataObject) {
        dataObject = {}
      }
      dataObject.method = 'SENDMAIL'
      dataObject.type = 'files'
      dataObject.guid = guids.join()
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(dataObject),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    updateStorageItemExtraFields: function (guid, extraFields, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'UPDATE',
        type: 'filesExtraFields',
        guid: guid,
        extraFields: extraFields
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    getFileDownloadURL: function (guid) {
      var url = this.gbl_host + '/storage/item?method=DOWNLOAD&type=files&guid=' + guid + '&token=' + Vue.prototype.$api.getAuthToken() + '&time=' + new Date().getTime()
      return url
    },
    getEntitiesFromStorageItem: function (guid, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'ENTITIES',
        type: 'find',
        guid: guid
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Retrieves a list of categories
     * @param fnSuccess
     * @param fnError
     */
    getStorageCategories: function (fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'LIST',
        type: 'categories',
        name: ''
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    replaceAll: function (target, search, replacement) {
      let str = target
      try {
        str = str.replace(new RegExp(search, 'g'), replacement)
      } catch (e) {}
      try {
        str = ('' + str).replaceAll(search, replacement)
      } catch (e) {}
      return str
    },
    getPreviewUpdateOfItem: function (sid, page, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'PREVIEW',
        type: 'PAGE',
        page: page,
        sid: sid
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Retrieves a list of jobs of given sid
     * @param fnSuccess
     * @param fnError
     */
    getJobsOfItem: function (sid, fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'LIST',
        type: 'JOBS',
        sid: sid
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Retrieves a list of status
     * @param fnSuccess
     * @param fnError
     */
    getStorageStatus: function (fnSuccess, fnError) {
      let url = this.gbl_host + '/storage/item'
      var params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }
      let reqData = {
        method: 'LIST',
        type: 'status',
        name: ''
      }
      axios({
        method: 'post',
        url: url,
        params: params,
        data: JSON.stringify(reqData),
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    },
    /**
     * Return the dms status with some states for informations
     * @param fnSuccess
     * @param fnError
     */
    getStatus: function (fnSuccess, fnError) {
      Vue.prototype.$api.showIdle()
      let url = this.gbl_host + '/status'
      let params = {
        time: new Date().getTime(),
        token: Vue.prototype.$api.getAuthToken()
      }

      axios({
        method: 'get',
        params: params,
        url: url,
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        }).catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    }
  }}
)
export default DMS



// WEBPACK FOOTER //
// ./src/dms.js